export const LIST_CORPORATE = 'src/Admin/Corporate/MeteringStats/LIST_CORPORATE';
export const LIST_CORPORATE_SUCCESS = 'src/components/Corporate/Create/action/LIST_CORPORATE_Success';
export const LIST_CORPORATE_FAILURE = 'src/components/Corporate/Create/action/LIST_CORPORATE_Failure';
export const REPORT_BY_DATE = 'src/Admin/Corporate/MeteringStats/REPORT_BY_DATE';
export const REPORT_BY_DATE_SUCCESS = 'src/components/Corporate/Create/action/REPORT_BY_DATE_Success';
export const REPORT_BY_DATE_FAILURE = 'src/components/Corporate/Create/action/REPORT_BY_DATE_Failure';

export const listCorporate = () => {
    return {
        type: LIST_CORPORATE,
    }
}

export const listCorporateSuccess = (data) => {
    return {
        type: LIST_CORPORATE_SUCCESS,
        data
    }
}

export const listCorporateFailure = (error) => {
    return {
        type: LIST_CORPORATE_FAILURE,
        error
    }
}

export const reportByDate = (data) => {
    return {
        type: REPORT_BY_DATE,
        data
    }
}

export const reportByDateSuccess = (data) => {
    return {
        type: REPORT_BY_DATE_SUCCESS,
        data
    }
}

export const reportByDateFailure = (error) => {
    return {
        type: REPORT_BY_DATE_FAILURE,
        error
    }
}